import { Entity } from '../entity';

export enum BillableType {
    Billable = 'Billable',
    NoCharge = 'No Charge',
    NotBillable = 'Not Billable'
}

export interface WorkType extends Entity {
    billable: BillableType;
    increment: number;
    multiplier: number;
    minimumDuration: number;
    system?: boolean;

    /** @description Restrict to Time Segments Only */
    restrictToTimeSegment?: boolean;
}

export type WorkTypeCommandRequest =
    {
        commandId: 'NameExists';
        data: {
            name: string;
            _id?: string;
        }
    }
